import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const AllRepaymentNavUI = ({ context, type, version, year, month }) => {
  // Determine the page prop based on type and version
  const page =
    // type === 'non-retail' && version === 'v1' ? 'emi_tracker_v1' :
    //   type === 'non-retail' && version === 'v2' ? 'emi_tracker_v2' :
    //     type === 'retail' && version === 'v1' ? 'retail_v1' :
    //       type === 'retail' && version === 'v2' ? 'retail_v2' :
    //         type === 'prior' ? 'prior' :
    //           type === 'collections' ? 'collections' :
                type === 'emi_tracker_2.0_business' ? 'emi_tracker_2.0_business' :
                type === 'emi_tracker_2.0_retail' ? 'emi_tracker_2.0_retail' :
                  '';

  return (
    <div className='g_flex_h g_flex_left g_flex_wrap g_m_bottom_50'>
      {
        context.filter === 'classic' &&
        <>
          {/* <TabLinkUI label='EMI Tracker V1' to={`/su/repayments/v1/non-retail/${year}/${month}`} active={page === 'emi_tracker_v1'} /> */}
          {/* <TabLinkUI label='EMI Tracker V2' to={`/su/repayments/v2/non-retail/${year}/${month}`} active={page === 'emi_tracker_v2'} /> */}
          <TabLinkUI label='EMI Tracker 2.0 (Business)' to={`/su/repayments/2.0/${year}/${month}`} active={page === 'emi_tracker_2.0_business'} />
          <TabLinkUI label='EMI Tracker 2.0 (Retail)' to={`/su/repayments/2.0/${year}/${month}/retail`} active={page === 'emi_tracker_2.0_retail'} />
          {/* <TabLinkUI label='Retail V1' to={`/su/repayments/v1/retail/${year}/${month}`} active={page === 'retail_v1'} /> */}
          {/* <TabLinkUI label='Retail V2' to={`/su/repayments/v2/retail/${year}/${month}`} active={page === 'retail_v2'} /> */}
          {/* <TabLinkUI label='Overdues' to={`/su/overdues/${year}/${month}`} active={page === 'prior'} /> */}
          {/* <TabLinkUI label='EMI Collections' to={`/su/emis/${year}/${month}`} active={page === 'collections'} /> */}
        </>
      }
      {
        context.filter === 'stp' &&
        <>
          <TabLinkUI label='EMI Tracker 2.0' to={`/su/repayments/2.0/${year}/${month}`} active={page === 'emi_tracker_2.0'} />
        </>
      }
    </div>
  );
};

export default AllRepaymentNavUI;
